import { useEffect } from 'react';
import { Eye } from 'lucide-react';
import { useImpersonation } from '@/hooks/useImpersonation';
import './ImpersonationBanner.css';

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useImpersonation();

  useEffect(() => {
    if (isImpersonating) {
      document.body.classList.add('impersonation-banner-offset');
    } else {
      document.body.classList.remove('impersonation-banner-offset');
    }
    return () => {
      document.body.classList.remove('impersonation-banner-offset');
    };
  }, [isImpersonating]);

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  const roleLabel = impersonatedUser.roles.join(', ') || 'no roles';

  return (
    <div className="impersonation-banner" role="alert">
      <Eye size={16} className="impersonation-banner__icon" aria-hidden="true" />
      <span className="impersonation-banner__text">
        Viewing as{' '}
        <span className="impersonation-banner__name">
          {impersonatedUser.display_name || impersonatedUser.email}
        </span>{' '}
        <span className="impersonation-banner__roles">({roleLabel})</span>
      </span>
      <button
        className="impersonation-banner__switch-btn"
        onClick={stopImpersonation}
        type="button"
      >
        Switch back to Admin
      </button>
    </div>
  );
}
